import api from "./api";

/**
 * Buscar assinatura digital do responsável
 * para usar em documentos PDF
 */

// export const getNomeDirector = async (funcao) => {
//   const  response  = await api.get(`/admins?status=Activo&funcao=${funcao}`);
//   return response.data?.Admins[0] || '';
// }; 

export const getAssinaturaResponsavel = async (
  funcao = "Director Geral"
) => {
  try {
    const response = await api.get(
      `/admins?status=Activo&funcao=${funcao}`
    );

    const responsavel = response?.data?.Admins?.[0];

    if (!responsavel) {
      return null;
    }

    const fotoURL = responsavel?.dadosPessoais?.fotoURL || "";
    const assinaturaURL = responsavel?.assinatura || "";

    let fotoBase64 = "";
    let assinaturaBase64 = "";

    if (fotoURL) {
      try {
        const fotoResponse = await api.post('/get-imagebase64', {
          urls: [fotoURL]
        });

        fotoBase64 = fotoResponse?.data?.images?.[0] || "";
      } catch (error) {
        console.error("Erro ao converter foto:", error);
      }
    }

    if (assinaturaURL) {
      try {
        const fotoResponse = await api.post('/get-imagebase64', {
          urls: [assinaturaURL]
        });

        assinaturaBase64 = fotoResponse?.data?.images?.[0] || "";
      } catch (error) {
        console.error("Erro ao converter foto:", error);
      }
    }

    return {
      id: responsavel?._id,
      nome: responsavel?.dadosPessoais?.nome || "",
      funcao: responsavel?.funcao || "",
      email: responsavel?.email || "",
      assinatura: assinaturaBase64,
      foto: fotoBase64, // retorna já em base64
    };

  } catch (error) {
    console.error(
      "Erro ao buscar assinatura do responsável:",
      error
    );

    return null;
  }
};

// export const getAssinaturaResponsavel = async (
//   funcao = "Director Geral"
// ) => {

//   try {

//     const response = await api.get(
//       `/admins?status=Activo&funcao=${funcao}`
//     );

//     const responsavel = response?.data?.Admins?.[0];

//     if (!responsavel) {
//       return null;
//     }

//     return {
//       id: responsavel?._id,
//       nome: responsavel?.dadosPessoais?.nome || "",
//       funcao: responsavel?.funcao || "",
//       email: responsavel?.email || "",
//       assinatura: responsavel?.assinaturaURL || "",
//       foto: responsavel?.dadosPessoais?.fotoURL || "",
//     };

//   } catch (error) {

//     console.error(
//       "Erro ao buscar assinatura do responsável:",
//       error
//     );

//     return null;
//   }
// };

